import { render, staticRenderFns } from "./BaseConfirmModalForm.vue?vue&type=template&id=0b45d020&"
import script from "./BaseConfirmModalForm.vue?vue&type=script&lang=ts&"
export * from "./BaseConfirmModalForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
